// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"c50d8689","127":"75fa2f4a","168":"e22e9d57","470":"723c825e","649":"225ee3dc","661":"e181f57f","790":"a3b45769","887":"8f9d3cfb"}[chunkId] + ".chunk.js";
};